import { createSlice } from '@reduxjs/toolkit';

export const majorPlan = createSlice({
    name: 'majorPlan',
    initialState: {
        data: ['beforeFetch']
    },
    reducers: {
      fetchSuccess(state, action) {
        const { payload } = action;
        state.data = payload;
      },
    },
}).reducer;